var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import styled from "styled-components";
import { elevation, gridSize, borderRadius, typography, colors } from "@atlaskit/theme";
import VidPlayIcon from "@atlaskit/icon/glyph/vid-play";
import { LoadingButton } from "@atlaskit/button";
import { Form } from "@atlassiansox/microscopekit";
import { useExecuteRecommendedFault } from "./useExecuteRecommendedFault";
import { TextSelect } from "../../FormView";
import { useAnalytics } from "../../../analytics";
export var RecommendedFaultCard = function (_a) {
    var id = _a.id, name = _a.name, mainParameterValue = _a.mainParameterValue, description = _a.description, lastMonthExecutionCount = _a.lastMonthExecutionCount, supportedEnvironments = _a.supportedEnvironments, isWargameInProgress = _a.isWargameInProgress;
    var _b = useExecuteRecommendedFault(), isLoading = _b.isLoading, mutate = _b.mutate;
    var _c = __read(useState(""), 2), environment = _c[0], setEnvironment = _c[1];
    var sendUIEvent = useAnalytics().sendUIEvent;
    var onExecute = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            mutate({ recommendedFaultId: id, environment: environment });
            sendUIEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "executeRecommendedFault",
                source: "homeScreen",
                attributes: {
                    recommendedFaultId: id,
                    environment: environment
                }
            });
            return [2 /*return*/];
        });
    }); };
    var onEnvironmentSelected = function (selectedEnvironment) {
        setEnvironment(selectedEnvironment);
        sendUIEvent({
            action: "selected",
            actionSubject: "dropdown",
            actionSubjectId: "environmentRecommendedFault",
            source: "homeScreen",
            attributes: {
                recommendedFaultId: id,
                environment: selectedEnvironment
            }
        });
    };
    return (React.createElement(Container, null,
        React.createElement(Name, null, name),
        mainParameterValue !== "<nil>" ? (React.createElement(MainParameterValue, null, mainParameterValue)) : (React.createElement(MainParameterValue, null, "\u00A0")),
        React.createElement(Description, null, description),
        React.createElement(ExecutionCount, null,
            "Executed\u00A0",
            React.createElement(ExecutionCountValue, null,
                lastMonthExecutionCount,
                " times"),
            "\u00A0last month"),
        React.createElement(ExecuteRecommendedFaultForm, { onSubmit: onExecute },
            React.createElement(EnvironmentSelectContainer, null,
                React.createElement(TextSelect, { label: "Environment", name: "environment", options: supportedEnvironments, isRequired: true, onChange: onEnvironmentSelected, value: environment })),
            "\u00A0\u00A0",
            React.createElement(ExecuteButton, { type: "submit", appearance: "primary", iconBefore: React.createElement(VidPlayIcon, { label: "Execute Wargame Plan" }), isLoading: isLoading, isDisabled: isWargameInProgress }, "Execute"))));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  border-radius: ", "px;\n  padding: ", "px;\n"], ["\n  ", "\n  border-radius: ", "px;\n  padding: ", "px;\n"])), elevation.e100, borderRadius(), gridSize() * 1.5);
var Name = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typography.h500);
var MainParameterValue = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  margin-top: ", "px;\n"], ["\n  ", "\n  margin-top: ", "px;\n"])), typography.h600, gridSize());
var Description = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-height: 2.5rem;\n"], ["\n  min-height: 2.5rem;\n"])));
var ExecutionCount = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  margin-top: ", "px;\n"], ["\n  ", "\n  margin-top: ", "px;\n"])), typography.h500, gridSize());
var ExecutionCountValue = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.G500);
var ExecuteRecommendedFaultForm = styled(Form)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  margin-top: ", "px;\n"], ["\n  display: flex;\n  margin-top: ", "px;\n"])), gridSize());
var EnvironmentSelectContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));
var ExecuteButton = styled(LoadingButton)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), gridSize() * 4.5);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
